import React from 'react';

export default function ActionAlert ({ 
  setShowAlert, 
  alertText, 
  button1Text, 
  button2Text, 
  onButton1Click, 
  onButton2Click 
}) {
  return (
    <div 
      className="bg-blue-100 border-blue-500 text-blue-700 px-4 py-3 relative rounded shadow-sm" 
      role="alert" 
      style={{ display: "block"}}
    > 
      {/* Close Button */}
      <button 
        className="absolute top-2 right-2 text-lg font-normal text-gray-700 hover:text-gray-900 transition-colors" 
        onClick={() => setShowAlert(false)}
        aria-label="Close alert"
      >
        X
      </button> 
      
      {/* Alert Content */}
      <div className="pr-6">
        <span className="text-sm block font-medium mb-2">{alertText}</span> 

        {/* Action Buttons */}
        <div className="flex gap-2 mt-2">
          <button 
            className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold py-1.5 px-3 rounded transition-colors"
            onClick={onButton1Click}
          >
            {button1Text}
          </button>
          
          <button 
            className="bg-white hover:bg-gray-50 border border-blue-500 text-blue-600 text-xs font-semibold py-1.5 px-3 rounded transition-colors"
            onClick={onButton2Click}
          >
            {button2Text}
          </button>
        </div>
      </div>
    </div>
  );
};
